module.exports = __webpack_public_path__ + "f08aae24d5572f3e9e44d38aa991b7ba.svg";